export default "__VITE_ASSET__LMaw4gHg__"